import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  fetchCurrentUser,
  setSelected,
  changeArchives,
  archiveNotification
} from "./redux/notificationsSagas";
import { useSelector } from "react-redux";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { PopupFilters } from "./smartComponents/PopupFilters";
import { Delete } from "./smartComponents/Delete";
import { Preview } from "./smartComponents/Preview";
import PropTypes from "prop-types";
import { xlsxExport } from "../../../utils/xlsxExport";
import "./notifications.scss";
import {
  Trash,
  Preview as Prev,
  Download,
  Edit,
  Archive,
  Unarchive
} from "../../../assets/images/svg";
import { api } from "./services/api";
import ToggleableButton from "../../../components/toggleableButton/toggleableButton";

export function NotificationsModule({ params }) {
  const dispatch = useDispatch();
  const { isLoading, notifications, isNotificationsLoading } = useSelector(
    (state) => state.notifications
  );
  const { archives } = useSelector((state) => state.notifications);
  const [popup, setPopup] = useState({
    popupFilter: false,
    delete: false,
    preview: false
  });

  const openPopup = (type) => {
    setPopup((prev) => ({ ...prev, [type]: true }));
  };

  const closePopup = (type) => {
    return () => setPopup((prev) => ({ ...prev, [type]: false }));
  };

  const handlePopup = (notificationId, type) => {
    dispatch(setSelected({ notificationId }));

    openPopup(type);

    if (type === "popupFilter" || type === "preview") {
      let selectedNotification = notifications.find(
        (notification) => notification.id === notificationId
      );
      dispatch(setSelected({ ...selectedNotification }));
    }
  };

  const archive = (notificationId, isArchive) => {
    dispatch(archiveNotification({ id: notificationId, archived: isArchive }));
  };

  const onClickSwitchToArchives = (isActive) => {
    dispatch(changeArchives(isActive));
  };

  const getConfirmations = async (id, index) => {
    try {
      const res = await api.getConfirmations({ params: { id } });
      const { data, colHeaders } = res.data.confirmations;
      xlsxExport({
        data,
        headers: colHeaders,
        fileName: "confirmations" + (index + 1),
        download: true
      });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    dispatch(fetchCurrentUser(params));
  }, []);

  if (isLoading)
    return (
      <div className="light">
        <LoadingAnimation />
      </div>
    );

  return (
    <div className="notifications">
      <div className="notifications__add">
        <button onClick={() => openPopup("popupFilter")} className="button button--primary">
          Add Notification
        </button>
      </div>

      <div className="switch switch-to-archived">
        <p className="switch__title">Switch to archived notifications</p>
        <div className={`switch__content ${archives ? "switch__content--active" : ""}`}>
          <ToggleableButton
            isRadio
            title="showArchiveList"
            isActive={archives}
            onClick={onClickSwitchToArchives}
          />
        </div>
      </div>

      <div className="notifications__content">
        <ul className="group">
          {isNotificationsLoading ? (
            <div className="light">
              <LoadingAnimation />
            </div>
          ) : (
            notifications.map(({ id, title, published, created_by, archived }, index) => (
              <li color="dark" className="group__item" key={index}>
                <div className="group__item__el text">
                  {index + 1}. {title}
                </div>
                <div className={`group__item__el status ${published ? "active" : ""}`}>
                  {published ? "Published" : "Unpublished"}
                </div>
                <div className="group__item__el createdBy">Created by {created_by}</div>
                <div className="group__item__el preview">
                  <span
                    className="group__icon"
                    title="Preview"
                    onClick={() => handlePopup(id, "preview")}
                  >
                    <Prev />
                  </span>
                </div>
                <div className="group__item__el confirmations">
                  <span
                    className="group__icon"
                    onClick={() => getConfirmations(id, index)}
                    title="Confirmations"
                  >
                    <Download />
                  </span>
                </div>
                <div className="group__item__el edit">
                  <span
                    className="group__icon"
                    onClick={() => handlePopup(id, "popupFilter")}
                    title="Edit"
                  >
                    <Edit />
                  </span>
                </div>
                <div className="group__item__el">
                  {archived ? (
                    <span
                      className="group__icon"
                      onClick={() => archive(id, false)}
                      title="Unarchive"
                    >
                      <Unarchive />
                    </span>
                  ) : (
                    <span className="group__icon" onClick={() => archive(id, true)} title="Archive">
                      <Archive />
                    </span>
                  )}
                </div>
                <div className="group__item__el delete">
                  <span
                    className="group__icon"
                    onClick={() => handlePopup(id, "delete")}
                    title="Delete"
                  >
                    <Trash color="#FF0000" />
                  </span>
                </div>
              </li>
            ))
          )}
        </ul>
      </div>

      <PopupFilters isOpen={popup.popupFilter} onClose={closePopup("popupFilter")} />

      <Delete isOpen={popup.delete} onClose={closePopup("delete")} />

      <Preview isOpen={popup.preview} onClose={closePopup("preview")} />
    </div>
  );
}

NotificationsModule.propTypes = {
  params: PropTypes.object
};
